<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      <div class="row">
        <div class="col-12">
          <img class="document-img" :src="document" alt>
        </div>
      </div>
      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back"
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <div class="section-new-doc"> 
              <!-- <img
                class="cross-circle-img"
                src="@/assets/logout-copy-2.svg"
                alt
              /> 
              <span class="add-new-document">Send Via Email</span> -->
              <img
                class="cross-circle-img"
                src="@/assets/download.svg"
                alt
              /> 
              <a :href="document" style="text-decoration: none;"><span class="add-new-document">View Document</span></a>
            </div>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: "fullDocumentShow",
  props: {
    empId: {
      type: Object,
      default: null
    },
    document: {
      type: Object
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      showUnAssignModal: false,
    };
  },
  computed: {
    
  },

  mounted() {
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
  },

  methods: {
  }
};
</script>

<style lang="scss" scoped>
.cross-circle-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.document-img {
  width: 100%;
  text-align: center;
}

.file-title {
  width: 313px;
  height: 58px;
  padding: 20px;
  margin-left: -1px;
  border-radius: 0px;
  text-align: left;
  border: solid 1px #e4e4e4;
}

.file-name {
  font-weight: bold;
  color: #444444;
}

.file-size {
    display: block;
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1rem;
    letter-spacing: normal;
    color: #444444;
}

.box-rectangle {
    max-width: 313px;
    height: 291px;
    margin: 32px 0px 0px 16px;
    border-radius: 4px;
    border: solid 1px #e4e4e4;
    text-align: center;
    padding: 0px 0px 0px;
    position: relative;
}

.section-new-doc {
  cursor: pointer;
  display: inherit;
}

.add-new-document {
  width: 161px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}

.action-section:hover {
  .action-menu {
    display: block;
  }
}
.action-section {
  display: inline-block;
  margin-left: 15px;
  text-align: center;

  img {
    width: auto;
  }

  .action-menu {
    display: none;
    top: 0%;
    left: -140px;
    right: 0;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;
    li {
      padding: 0px;
      font-weight: 500;
      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }
      &:not(:last-child) {
        span {
          border-bottom: solid 1px #979797;
        }
      }
    }
  }
}
.flex-box {
  display: flex;
  .row-container {
    margin-right: 20px;
  }
  margin-bottom: 60px;
}

.text-green {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 600;
  color: #34c0be;
}

.margin-left-20 {
  margin: 20px 36px 0px 0px;
}

.card {
  display: flex;
  width: 25%;
  margin-right: 12px;
  height: 110px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  margin-left: 20px;
}

.image {
  .alignImage {
    width: 100px;
    height: 100px;
    padding: 10px 0 0 10px;
  }
}

.emp-details {
  padding: 20px 0 0 10px;
  color: #535353;
}

.Rectangle {
  width: 316px;
  height: 102px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
}

.close-card {
  cursor: pointer;
  color: #6e6e6e;
  width: 12px;
  height: 12px;
  padding: 2px 0 0 160px;
}

.bottom-75 {
  margin-bottom: 75px;
}
.text {
  width: 622px;
  height: 74px;
  font-family: Montserrat;
  font-size: 14px;
  color: #9c9c9c;
}

.content-new {
  margin: 30px 77px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717; // padding-top: 1px
  }
}

footer {
  height: 50px;
  flex-shrink: 0;
}

.business {
  width: 100%;
  height: 100%;
}

.business .top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.refresh-icon {
  cursor: pointer;
}

.errorr {
  border: 1px solid #e01717;
}

.errorMessage {
  color: #e01717; // padding-top: 1px
}

.selectdiv select {
  width: 300px;
  height: 35px;
  border-radius: 4px;
  outline: 0;
  font-size: 14px;
  color: black;
  border: 1px solid #a7a7a7;
  padding: 0 10px;
  /* needed */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* SVG background image */
  /* background: url("@/assets/stroke-1.png"); */
  background-size: 12px;
  background-position: calc(100% - 10px) center;
  background-repeat: no-repeat;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 93px;
  height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.line {
  margin-left: 4px;
  margin-bottom: 5px;
  margin-top: 18px;
  margin-right: 30px;
  border-bottom: 1px solid #34c0be;
}

.contbtn {
  margin-top: 30px;
  float: right;
  margin-right: 30px;
  width: 154px;
  height: 45px;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
  color: #ffffff;
}

.form-button {
  margin-top: 10px;
  margin-bottom: 5%;
}

.custom-width {
  width: 300px;
}

.datatable-outer-container {
  width: auto;
  table.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    font-family: Montserrat;
    margin-bottom: 4px;
    //   table-layout: fixed;

    .header-row {
      background-color: white;
      height: 54px;
      th {
        background-color: #f0f1f5;
        border-bottom: 0px solid #34c0be;
        padding: 6px 8px;
        //   text-align: center;
      }
    }
    .inactiveCols {
      opacity: 0.03;
      background-color: #a2a1a1;
    }
    // for datatable2
    .Editdeleteheader {
      background-color: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);

      th {
        // border-right: 1px solid #ececec;
        padding: 0 8px;
        // display: flex;
        span {
          border-right: 1px solid #ececec;
          padding: 0px 18px 0px 15px;
          display: inline-block;
          vertical-align: middle;
          &:first-child {
            padding: 10px 10px 7px 10px;
          }
        }
        &:last-of-type {
          text-align: right;
          span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
            //    display: block;
            i {
              position: absolute;
              right: 10px;
              top: 2px;
            }
          }
        }
      }
    }
    .record-row {
      height: 54px;
      border-bottom: 0px solid #d8d8d8;
      //   text-align: center;
      &:nth-child(odd) {
        background-color: #f5f6fa;
      }
      &.selectedRecord {
        background-color: #e9f9f8;
        opacity: 0.9;
      }

      td {
        padding: 6px 8px;
        color: #000000;
      }

      .action-img {
        display: block;
        cursor: pointer;
        opacity: 0.1;
      }

      &:hover {
        .action-img {
          opacity: 1;
        }
      }
    }
  }
}

.custom-input {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 100%;
  max-width: 300px;
  height: 35px;
  -webkit-transition: ease-in-out, width 0.35s ease-in-out;
  transition: ease-in-out, width 0.35s ease-in-out;
  :focus {
    border: 1px solid #34c0be;
  }
}

.advanced-Setting {
  width: auto;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #5d409f;
  text-decoration: underline;
  cursor: pointer;
}

.un-assign-text {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  color: #646464;
  text-align: center;
}

.margin-top-30 {
  margin-top: 30px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-10 {
  margin: 10px;
}
</style>
